import React from 'react';
import { AlertCircle, CheckCircle2, Clock, ArrowRight } from 'lucide-react';
import { normalizeImportance } from '../utils/formatters';

export default function TaskSummary({ results, filter = 'all' }) {
  if (!results || results.length === 0) return null;

  // Filter results based on sidebar filter
  let filteredResults = results;
  if (filter && filter !== 'all') {
    if (filter === 'critical') {
      filteredResults = results.filter((r) => normalizeImportance(r.importance) === 'critical');
    } else if (filter === 'important') {
      filteredResults = results.filter((r) => normalizeImportance(r.importance) === 'important');
    } else if (filter === 'routine') {
      filteredResults = results.filter((r) => normalizeImportance(r.importance) === 'routine');
    } else if (filter === 'low') {
      filteredResults = results.filter((r) => normalizeImportance(r.importance) === 'low');
    } else if (filter === 'starred') {
      filteredResults = results.filter((r) => {
        const t = normalizeImportance(r.importance);
        return t === 'critical' || t === 'important';
      });
    }
  }

  const critical = filteredResults.filter((r) => normalizeImportance(r.importance) === 'critical');
  const important = filteredResults.filter((r) => normalizeImportance(r.importance) === 'important');
  const actionItems = [...critical, ...important];

  if (actionItems.length === 0) return null;

  const handleTaskClick = (emailId) => {
    const element = document.querySelector(`[data-email-id="${emailId}"]`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.style.animation = 'none';
      setTimeout(() => {
        element.style.animation = 'fadeSlideUp 0.4s ease-out';
      }, 10);
    }
  };

  return (
    <div className="task-summary">
      <div className="task-summary-header">
        <div className="task-summary-title">
          <AlertCircle size={18} />
          <span>Action Items</span>
          <span className="task-count">{actionItems.length}</span>
        </div>
        <span className="task-subtitle">Auto-extracted from your priority emails</span>
      </div>
      <ul className="task-list">
        {actionItems.map((item, i) => (
          <li 
            key={item._resultKey || `${item.email?.id || i}-${i}`} 
            className={`task-item task-${normalizeImportance(item.importance)}`}
            onClick={() => handleTaskClick(item.email?.id)}
            style={{ cursor: 'pointer' }}
          >
            <div className="task-bullet">
              {normalizeImportance(item.importance) === 'critical' ? (
                <AlertCircle size={14} />
              ) : (
                <Clock size={14} />
              )}
            </div>
            <div className="task-content">
              <div className="task-text">{item.summary?.replace(/\*\*/g, '').slice(0, 120)}</div>
              <div className="task-meta">
                <span className="task-sender">{item.email?.sender}</span>
                <ArrowRight size={10} />
                <span className="task-reason">{item.reason}</span>
              </div>
            </div>
            <span className={`task-badge ${normalizeImportance(item.importance)}`}>
              {normalizeImportance(item.importance)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
